import { ApiService } from "./api.service";
import type { IWorkspaceExportData, IWorkspaceExportResponse } from "@/types/workspace";

export interface IWorkspaceExportRequest {
  provider: "csv" | "xlsx" | "json";
  project: string[];
  multiple?: boolean;
  rich_filters?: Record<string, unknown>;
}

export class WorkspaceExportService extends ApiService {
  async createExport(slug: string, data: IWorkspaceExportRequest): Promise<IWorkspaceExportData> {
    return this.post(`/api/workspaces/${slug}/export-issues/`, data);
  }

  async listExports(
    slug: string,
    params: { per_page?: number; cursor?: string } = {},
  ): Promise<IWorkspaceExportResponse> {
    const { per_page = 10, cursor = "" } = params;
    return this.get(`/api/workspaces/${slug}/export-issues/`, {
      params: { per_page, cursor },
    });
  }
}
